/*
 * @Author: etong
 * @Date: 2023-06-19 14:08:00
 * @LastEditTime: 2023-06-28 10:37:17
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\modules\routerMap\views\cstore.js
 * Think first, Program later
 */
// C店
const map = {
  cstoreGoodList: () => import('@/views/cstore/CstoreGoodList'),
  newCalendar: () => import('@/views/cstore/NewCalendar'),
  activityDetail: () => import('@/views/cstore/ActivityDetail'),
  auditedGoods: () => import('@/views/cstore/AuditedGoods'),
  quantityGoods: () => import('@/views/cstore/QuantityGoods'),
  cstoreRemind: () => import('@/views/cstore/CstoreRemind'),
  productMap: () => import('@/views/cstore/ProductMap'),
  weatherDataMonitoring: () => import('@/views/cstore/WeatherDataMonitoring'), // 天气数据监控
  shopLinkProfit: () => import('@/views/cstore/ShopLinkProfit'), // 店铺链接利润
  productPersonConfig: () => import('@/views/cstore/ProductPersonConfig'),
  productPersonlConfigDetail: () => import('@/views/cstore/ProductPersonConfig/Detail'),
  productGoalConfig: () => import('@/views/cstore/ProductGoalConfig'),
  productBusinessPropertyConfigDetail: () => import('@/views/cstore/ProductGoalConfig/ProductBusinessPropertyConfigDetail'), // 类目目标配置详情
  productBusinessProperty: () => import('@/views/cstore/ProductBusinessProperty')

}

export default map
